import apiService from "./apiService";
import AppConstants from "../appConstants";

class CategoryService {
    getAllCategory(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CATEGORY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCategoryDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CATEGORY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerCategory(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CATEGORY, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteCategory(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CATEGORY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CATEGORY_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new CategoryService();
